import styled from "@emotion/styled"
import { PIcon } from "@porsche-design-system/components-react"
import { spacingStaticLg, spacingStatic2Xl } from "@porsche-design-system/components-react/emotion"
import type { VehicleHistoryListInventoryItem, VehicleHistoryTeaser } from "@slfinrtl/ui-bff-routes"
import { defineMessages, FormattedMessage } from "react-intl"
import { Stage } from "src/components/stage/Stage"
import { VehicleHistoryHeader } from "../vehicleHistoryHeader/VehicleHistoryHeader"
import { VehicleHistoryHeaderSkeleton } from "../vehicleHistoryHeader/VehicleHistoryHeaderSkeleton"
import { VehicleHistoryList } from "../vehicleHistoryList/VehicleHistoryList"
import { VehicleHistoryListSkeleton } from "../vehicleHistoryList/VehicleHistoryListSkeleton"

const messages = defineMessages({
	empty: {
		defaultMessage: "Search for a VIN.",
		id: "vehicleHistory.empty",
	},
	error: {
		defaultMessage: "No result found. Please try a different search.",
		id: "vehicleHistory.error",
	},
})

interface VehicleHistoryStageProps {
	error?: any
	hasTeaser?: boolean
	isValidating: boolean
	teaser?: VehicleHistoryTeaser | null
	timeZone?: string
	vehicleHistoryListInventoryItems?: VehicleHistoryListInventoryItem[]
}

export const VehicleHistoryStage = ({
	error,
	hasTeaser,
	isValidating,
	teaser,
	timeZone,
	vehicleHistoryListInventoryItems,
}: VehicleHistoryStageProps) => {
	return vehicleHistoryListInventoryItems ? (
		<LayoutStage>
			{teaser !== undefined && <VehicleHistoryHeader teaser={teaser} />}
			<VehicleHistoryList timeZone={timeZone} items={vehicleHistoryListInventoryItems} />
		</LayoutStage>
	) : isValidating ? (
		<LayoutStage>
			{hasTeaser && <VehicleHistoryHeaderSkeleton />}
			<VehicleHistoryListSkeleton />
		</LayoutStage>
	) : error || vehicleHistoryListInventoryItems === null ? (
		<EmptyStage>
			<PIcon name="car" size="lg" />
			<FormattedMessage {...messages.error} />
		</EmptyStage>
	) : (
		<EmptyStage>
			<PIcon name="car" size="lg" />
			<FormattedMessage {...messages.empty} />
		</EmptyStage>
	)
}

const LayoutStage = styled(Stage)`
    display: flex;
    flex-direction: column;
    gap: ${spacingStaticLg};
`

const EmptyStage = styled(Stage)`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: ${spacingStatic2Xl} 0;
`
